import React, { useEffect, useState } from 'react';
import validationAuth from '../../../validationAuth';
import {Box,Button,Typography,Table,TableBody,TableCell,TableContainer,
    TableHead,TablePagination,TableRow,Paper,Pagination,IconButton,Grid,Modal,Select,MenuItem, TextField,
    Snackbar,Alert} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import * as common from '../../../commons/common';
import SearchArea from '../../../components/managerPage/searchArea';
import ButtonOnTable from '../../../components/managerPage/gridTable';
import ExcelFilterModal from '../../../components/Modal/ExcelFilterModal';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const CustomerVoice = () => {
    const [searchFacilityNm, setSearchFacilityNm] = useState('');
    const [searchCheckerNm, setSearchCheckerNm] = useState('');
    const [items, setItems] = useState([]); //고객의 소리 리스트

    const [goToPage, setGoToPage] = useState('');
    const [selectedComplaint, setSelectedComplaint] = useState(null); //고객의 소리 상세 정보
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [status, setStatus] = useState('');
    const [statusOptions, setStatusOptions] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [searchParams, setSearchParams] = useState({
        checkerNm: '',
        facilityNm: '',
        pageSize: '',
        page: '',
    });
    const [isOpenExcelPop, setIsOpenExcelPop] = useState(false);

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalElements, setTotalElements] = useState(0);

    const [progressItems, setProgressItems] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [processContent, setProcessContent] = useState('');

    const [statusError, setStatusError] = useState("");

    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage]);

    // 고객의 소리 리스트 가져오기
    // 고객의 소리 리스트 가져오기
    const fetchData = async (params = {}) => {
        const url = `${common.getApiUrl()}/complaint`;
        const token = localStorage.getItem('access_token');

        const trimmedSearchParams = Object.keys(searchParams).reduce((acc, key) => {
            const value = searchParams[key];
            acc[key] = typeof value === 'string' ? value.trim() : value;
            return acc;
        }, {});

        try {
            const params = {
                facilityNm: trimmedSearchParams.facilityNm,
                checkerNm: trimmedSearchParams.checkerNm,
                page: page,
                pageSize: rowsPerPage,
            };

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                params
            });
            if (response.data && Array.isArray(response.data.content)) {
                const fetchedItems = response.data.content.map((item) => ({
                    id: item.complaintId,
                    registerDt: item.registerDt || '',
                    facilityNm: item.facilityNm || '',
                    complaintContent: item.complaintContent || '',
                    complaintStateNm: item.lastStateNm || item.complaintStateNm || '',
                }));
                setItems(fetchedItems);
                setTotalElements(response.data.totalElements);
            }
        } catch (error) {
            console.error("데이터를 가져오는 데 실패했습니다:", error);
        }
    };

    const handleSearchChanges = (name, value) => {
        if (name === 'facilityNm') {
            setSearchFacilityNm(value);
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value,
            }));
        } else if (name === 'checkerNm') {
            setSearchCheckerNm(value);
            setSearchParams(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleSearchSubmit = () => {
        setPage(1);
        fetchData();
    };

    const handleExcelPopOpen = () => {
        setIsOpenExcelPop(true)
    };

    const handleExcelPopClose = () => {
        setIsOpenExcelPop(false)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(1);
    };

    const handleGoToPage = (event) => {
        event.preventDefault();
        const pageNumber = parseInt(goToPage, 10);
        if (pageNumber > 0 && pageNumber <= Math.ceil(totalElements / rowsPerPage)) {
            setPage(pageNumber);
        }
        setGoToPage('');
    };

    // 고객의 소리 수정 모달 열기
    const handleOpenEditModal = async (complaintId) => {
        if (!complaintId) {
            console.error('Invalid complaintId');
            return;
        }

        try {
            const response = await axios.get(`${common.getApiUrl()}/complaint/${complaintId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
            });
            const data = response.data;
            setSelectedComplaint(data);
            setStatus(data.complaintStateVal);

            // 여기서 바로 progressItems 설정
            if (data.complaintStateList && data.complaintStateList.length > 0) {
                setProgressItems(data.complaintStateList.map(item => ({
                    complaintStateId: item.complaintStateId,
                    status: item.stateNm,
                    processContent: item.content || '',
                    checkTime: item.registerDt || new Date().toISOString(),
                })));
            } else {
                // 상태 이력이 없으면 기본값으로 하나의 항목 설정
                setProgressItems([{
                    status: data.complaintStateNm || '',
                    processContent: '',
                    checkTime: new Date().toISOString(),
                }]);
            }

            setEditModalOpen(true);
            fetchStatusOptions();
        } catch (error) {
            console.error('Error fetching complaint details:', error);
        }
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        setSelectedComplaint(null);
        setStatus('');
    };

    //고객의 소리 진행 단계 가져오기(공통코드)
    const fetchStatusOptions = async () => {
        const url = `${common.getApiUrl()}/common/comCd?comMstrId=CM6`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.data) {
                setStatusOptions(response.data);
            }
        } catch (error) {
            console.error('진행현황 옵션을 가져오는 데 실패했습니다:', error);
        }
    };

    // 새로운 핸들러 함수 추가
    const handleStatusChange = (index, event) => {
        const newProgressItems = [...progressItems];
        newProgressItems[index].status = event.target.value;
        setProgressItems(newProgressItems);
    };

    const handleProcessContentChange = (index, event) => {
        const newProgressItems = [...progressItems];
        newProgressItems[index].processContent = event.target.value;
        setProgressItems(newProgressItems);
    };

    // 진행 상황 항목 추가
    const handleAddProgressItem = () => {
        const currentTime = new Date().toISOString();
        setProgressItems([...progressItems, { status: '', processContent: '', checkTime: currentTime }]);
    };

    // 진행 상황 항목 삭제
    const handleRemoveProgressItem = async (index) => {
        const confirmDelete = window.confirm('정말 삭제하시겠습니까?');

        if (confirmDelete) {
            try {
                const token = localStorage.getItem('access_token');

                if (progressItems[index].complaintStateId) {
                    const url = `${common.getApiUrl()}/complaint/state/${progressItems[index].complaintStateId}`;
                    await axios.delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    });
                }

                const newProgressItems = [...progressItems];
                newProgressItems.splice(index, 1);
                setProgressItems(newProgressItems);
            } catch (error) {
                console.error('항목 삭제 중 오류가 발생했습니다:', error);
            }
        }
    };

    // 개별 항목 저장 함수
    const handleSubmitItem = async (index) => {
        // 상태 선택 여부 확인
        if (!progressItems[index].status) {
            setStatusError("진행 상황을 선택해주세요.");
            return; // 저장 중단
        }

        try {
            setStatusError(""); // 오류 메시지 초기화

            const stateData = {
                stateVal: statusOptions.find(option => option.comDtlNm === progressItems[index].status)?.comDtlVal || '',
                stateNm: progressItems[index].status,
                content: progressItems[index].processContent,
            };

            const token = localStorage.getItem('access_token');

            if (progressItems[index].complaintStateId) {
                const url = `${common.getApiUrl()}/complaint/state/${progressItems[index].complaintStateId}`;
                await axios.put(url, stateData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
            } else {
                const url = `${common.getApiUrl()}/complaint/state`;
                await axios.post(url, {
                    ...stateData,
                    complaintId: selectedComplaint.complaintId,
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                });
            }

            setSnackbarOpen(true);
            fetchData();

            // 상태 목록 다시 로드
            const response = await axios.get(`${common.getApiUrl()}/complaint/${selectedComplaint.complaintId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;
            setSelectedComplaint(data);

            if (data.complaintStateList && data.complaintStateList.length > 0) {
                setProgressItems(data.complaintStateList.map(item => ({
                    complaintStateId: item.complaintStateId,
                    status: item.stateNm,
                    processContent: item.content || '',
                    checkTime: item.registerDt || new Date().toISOString(),
                })));
            }

        } catch (error) {
            console.error('변경 사항 저장 중 오류가 발생했습니다:', error);
        }
    };

    // 변경 사항 저장 버튼 클릭 시
    const handleSaveAllChanges = async () => {
        try {
            // 현재 선택된 마지막 항목만 저장
            const lastIndex = progressItems.length - 1;
            await handleSubmitItem(lastIndex);

            alert('모든 변경사항이 저장되었습니다.');
            handleCloseEditModal();
        } catch (error) {
            console.error('변경 사항 저장 중 오류가 발생했습니다:', error);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    // 날짜 형식 변환 함수
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    return (
        <Box sx={{ width: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h6'>고객의 소리</Typography>
            <Box sx={{ position: 'relative' }}>
                <SearchArea
                    searchValues={{ facilityNm: searchFacilityNm, checkerNm: searchCheckerNm }}
                    handleSearchChanges={(name, value) => { handleSearchChanges(name, value); }}
                    fields={[
                        {
                            fieldnm: '시설명',
                            name: 'facilityNm',
                            type: 'input',
                        },
                        {
                            fieldnm: '담당자',
                            name: 'checkerNm',
                            type: 'input',
                        }
                    ]}
                    onSearchClick={handleSearchSubmit}
                    showRightButton='true'
                    rightBtnText={"엑셀 다운로드"}
                    rightBtnbgcolor="var(--sub-excel-color)"
                    onRightBtnClick={handleExcelPopOpen}
                />
            </Box>
            <ExcelFilterModal open={isOpenExcelPop} onClose={handleExcelPopClose} excelType={'complaint'} searchParams={searchParams}/>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '10px', padding: '15px 10px' }}>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#F2F2F2' }}>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>시설명</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>접수 항목</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>접수일시</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '15%' }}>진행현황</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', width: '10%' }}>수정</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item, index) => (
                                <TableRow key={index} sx={{ height: '52px' }}>
                                    <TableCell align="center" sx={{ padding: '4px' }}>{item.facilityNm}</TableCell>
                                    <TableCell align="center" sx={{ padding: '4px' }}>{item.complaintContent}</TableCell>
                                    <TableCell align="center" sx={{ padding: '4px' }}>{item.registerDt}</TableCell>
                                    <TableCell align="center" sx={{ padding: '4px' }}>{item.complaintStateNm}</TableCell>
                                    <TableCell sx={{ padding: '4px' }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <ButtonOnTable text="수정" onClick={() => handleOpenEditModal(item.id)} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {Array.from({ length: rowsPerPage - items.length }).map((_, index) => (
                                <TableRow key={`empty-row-${index}`} sx={{ height: '54px' }}>
                                    <TableCell colSpan={5} sx={{ padding: '8px' }} />
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2, }}>
                    <Box>
                        <Pagination
                            count={Math.ceil(totalElements / rowsPerPage)}
                            page={page}
                            onChange={(event, newPage) => handleChangePage(event, newPage)}
                            showFirstButton
                            showLastButton
                        />
                    </Box>
                    <Box sx={{ position: 'absolute', top: 5, left: 0 }}>
                        <TablePagination
                            labelDisplayedRows={() => ''}
                            component="div"
                            page={page - 1}
                            count={totalElements}
                            rowsPerPageOptions={[10, 25, 50]}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            ActionsComponent={() => null}
                            onPageChange={() => null}
                        />
                    </Box>
                </Box>
            </Paper>
            {selectedComplaint && (
                <Modal
                    open={editModalOpen}
                    onClose={handleCloseEditModal}
                    sx={{
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    }}
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: 1000,
                            bgcolor: 'var(--main-white-color)',
                            boxShadow: 24,
                            p: 3,
                            borderRadius: 2,
                            outline: 'none'
                        }}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold' }}>
                                고객의 소리 현황표 수정
                            </Typography>
                            <IconButton onClick={handleCloseEditModal} size="small">
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ bgcolor: 'white', p: 3, borderRadius: 2 }}>
                            <Grid container spacing={2}>
                                {[
                                    ['시설명', selectedComplaint.facilityNm],
                                    ['관리처',`${selectedComplaint.midDeptNm} - ${selectedComplaint.botDeptNm}`],
                                    ['접수일시', selectedComplaint.registerDt],
                                    ['고객의 소리', selectedComplaint.complaintContent],
                                ].map(([label, value], index) => (
                                    <Grid item xs={12} key={index}>
                                        <Box sx={{ display: 'flex', borderBottom: '1px solid #e0e0e0', py: 0 }}>
                                            <Typography sx={{ width: '30%', fontWeight: 'bold' }}>{label}</Typography>
                                            <Typography sx={{ width: '70%' }}>{value || ''}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
                                        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                                            진행 상황 ({progressItems.length}개 항목)
                                        </Typography>
                                    </Box>
                                    <Paper elevation={0} sx={{ my: 2, overflowY: 'auto' }}>
                                        {progressItems.map((item, index) => (
                                            <Grid container alignItems="center" key={index} spacing={1} sx={{ mb: 1 }}>
                                                <Grid item xs={1}>
                                                    <Typography>{String(index + 1).padStart(2, '0')}</Typography>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Box>
                                                        <Select
                                                            fullWidth
                                                            size="small"
                                                            value={item.status}
                                                            onChange={(event) => handleStatusChange(index, event)}
                                                            displayEmpty
                                                            error={index === progressItems.length - 1 && !!statusError}
                                                        >
                                                            <MenuItem value="">선택</MenuItem>
                                                            {statusOptions.map((option) => (
                                                                <MenuItem key={option.comDtlId} value={option.comDtlNm}>
                                                                    {option.comDtlNm}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {index === progressItems.length - 1 && statusError && (
                                                            <Typography color="error" variant="caption" sx={{ display: 'block' }}>
                                                                {statusError}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Typography>{formatDate(item.checkTime)}</Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        value={item.processContent || ''}
                                                        autoComplete="off"
                                                        onChange={(event) => handleProcessContentChange(index, event)}
                                                    />
                                                </Grid>
                                                <Grid item xs={1}>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: '#1E88E5',
                                                            color: '#fff',
                                                            boxShadow: 'none',
                                                            '&:hover': { backgroundColor: '#1A4080' },
                                                            padding: '2px 4px',
                                                            minWidth: '70px',
                                                            fontSize: '1.0rem',
                                                        }}
                                                        onClick={() => handleSubmitItem(index)}
                                                    >
                                                        저장
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {index === progressItems.length - 1 && (
                                                        <IconButton
                                                            sx={{
                                                                color: '#1E88E5',
                                                                boxShadow: 'none',
                                                                '&:hover': { color: '#1A4080' },
                                                            }}
                                                            onClick={handleAddProgressItem}
                                                        >
                                                            <AddCircleOutlineIcon />
                                                        </IconButton>
                                                    )}
                                                    {index > 0 && (
                                                        <IconButton
                                                            sx={{
                                                                color: '#1E88E5',
                                                                boxShadow: 'none',
                                                                '&:hover': { color: '#1A4080' },
                                                            }}
                                                            onClick={() => handleRemoveProgressItem(index)}
                                                        >
                                                            <RemoveCircleOutlineIcon />
                                                        </IconButton>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Paper>
                                </Grid>
                            </Grid>
                            {/*<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>*/}
                            {/*    <Button*/}
                            {/*        variant="contained"*/}
                            {/*        sx={{*/}
                            {/*            backgroundColor: '#1E88E5',*/}
                            {/*            color: '#fff',*/}
                            {/*            boxShadow: 'none',*/}
                            {/*            '&:hover': {*/}
                            {/*                backgroundColor: '#1A4080',*/}
                            {/*            },*/}
                            {/*            mr: 2*/}
                            {/*        }}*/}
                            {/*        onClick={handleSaveAllChanges}*/}
                            {/*    >*/}
                            {/*        변경 사항 저장*/}
                            {/*    </Button>*/}
                            {/*    <Button*/}
                            {/*        variant="contained"*/}
                            {/*        sx={{*/}
                            {/*            backgroundColor: '#B1BBCC',*/}
                            {/*            color: '#fff',*/}
                            {/*            boxShadow: 'none',*/}
                            {/*            '&:hover': {*/}
                            {/*                backgroundColor: '#A0A9B3',*/}
                            {/*            }*/}
                            {/*        }}*/}
                            {/*        onClick={handleCloseEditModal}*/}
                            {/*    >*/}
                            {/*        취소*/}
                            {/*    </Button>*/}
                            {/*</Box>*/}
                        </Box>
                    </Box>
                </Modal>
            )}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    변경 사항이 저장되었습니다.
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default validationAuth(CustomerVoice);